import React , {Component} from 'react';
import {Line} from 'react-chartjs-2';
import firebase from 'firebase';

const database=firebase.database();



class Chart extends Component{
	
	
	constructor(props){
		
		super(props);
		this.state={
			data: {}
		}
	}

	componentWillMount = () => {
		let objToday = new Date()
		let months = new Array('Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio','Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre')
		let curMonth = months[objToday.getMonth()];
		let curMonth1 = months[objToday.getMonth()-1];
		let curMonth2 = months[objToday.getMonth()-2];

		let arreglo={mes1:0,mes2:0,mes3:0};

		firebase.database().ref('/Clientes').once('value').then(snap =>{
			snap.forEach(element => {
				let data = element.val();
				let fecha = new Date(data.createAt);
				if(data.createAt!= null)
				{
					let fecha = new Date(data.createAt);

					if(curMonth === months[fecha.getMonth()]){
						arreglo.mes1 = parseInt(arreglo.mes1) + 1;
					}
					if(curMonth1 === months[fecha.getMonth()]){
						arreglo.mes2 = parseInt(arreglo.mes2) + 1;
					}
					if(curMonth2 === months[fecha.getMonth()]){
						arreglo.mes3 = parseInt(arreglo.mes3) + 1;
					}
				}
			});
			
			this.setState({
				data: {labels: [curMonth2, curMonth1, curMonth],
				datasets: [
				  {
					label: 'Usuarios registrados',
					fill: false,
					lineTension: 0.1,
					backgroundColor: 'rgba(75,192,192,0.4)',
					borderColor: 'rgba(75,192,192,1)',
					borderCapStyle: 'butt',
					borderDash: [],
					borderDashOffset: 0.0,
					borderJoinStyle: 'miter',
					pointBorderColor: 'rgba(75,192,192,1)',
					pointBackgroundColor: '#fff',
					pointBorderWidth: 1,
					pointHoverRadius: 5,
					pointHoverBackgroundColor: 'rgba(75,192,192,1)',
					pointHoverBorderColor: 'rgba(220,220,220,1)',
					pointHoverBorderWidth: 2,
					pointRadius: 1,
					pointHitRadius: 10,
					data: [arreglo.mes3, arreglo.mes2, arreglo.mes1]
				  }
				]}
			})
		});

		
	}

	render() {
		return (
		  <div>
			<Line data={this.state.data} />
		  </div>
		);
	}
	

	
}

export default Chart;


// WEBPACK FOOTER //
// ./src/Components/Charts/Charts.js